import $ from 'jquery';

$(document).on('click', '.search-results__form-clear', function () {
  const $input = $(this)
    .closest('.search-results__form')
    .find('.search-results__form-input');
  $input.val('').trigger('focus');
});
